import clsx from "clsx";
import PlanFeatures from "./PlanFeatures";
import React from "react";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";

const SubscriptionPlanCard = ({
  setSelectedPlan,
  originalPrice,
  mostPopular,
  i,
  features = [],
  otherFeatures = [],
  onSubmit,
  loading,
}) => {
  const billingInfo = useRecoilValue(billingAtom);

  const getCost = () => {
    const cost = i.type === "annually" ? +i.cost / 12 : +i.cost;
    return cost.toFixed(2).replace(/\.00$/, "");
  };

  const getOriginalCost = () => {
    if (!originalPrice) return null;
    const cost = i.type === "annually" ? +originalPrice / 12 : originalPrice;
    return cost.toFixed(2).replace(/\.00$/, "");
  };

  const originalCost = getOriginalCost();
  const cost = getCost();

  const active_plan = billingInfo?.active_plan?.payment_plan;
  const next_plan = billingInfo?.next_plan?.payment_plan;

  const isCurrentPlan = active_plan?.id === i?.id;

  const getSubmitLabel = () => {
    if (active_plan) {
       if (next_plan?.id && i.id === active_plan?.id && billingInfo?.active_plan?.canceled) {
        return "Renew plan";
      }

      if (isCurrentPlan) {
        if (+active_plan.cost > 0 && !billingInfo?.active_plan?.canceled) {
          return "Cancel Plan";
        }
        return "Current Plan";
      }

      if (next_plan?.id && i.id === next_plan?.id) {
        return "Pending plan";
      }

      if (+i.cost < +active_plan.cost) {
        return "Downgrade";
      }

      if (+i.cost > +active_plan.cost) {
        return "Upgrade";
      }
    }

    return "Select plan";
  };

  const submitLabel = getSubmitLabel();

  const Button = mostPopular ? PrimaryButton : SecondaryButton;

  return (
    <div
      onClick={() => setSelectedPlan(i)}
      className={clsx(
        "border-2 shadow-lg p-6 flex flex-col gap-6 relative bg-white w-full max-sm:min-w-[80vw]",
        {
          "rounded-xl": !mostPopular,
          "rounded-b-xl": mostPopular,
          "border-primary": isCurrentPlan,
        }
      )}
    >
      {mostPopular && (
        <div
          className={clsx(
            "w-full absolute -top-9 left-0 p-2 rounded-t-xl text-white font-bold text-sm text-center bg-primary"
          )}
          style={{
            zIndex: 9999,
          }}
        >
          Most popular
        </div>
      )}

      <div className="flex">
        <span className="inline-flex items-center rounded-full bg-secondaryHover px-2 py-1 text-sm font-medium ring-1 ring-inset ring-secondary text-primary">
          {i.name}
        </span>
      </div>

      <div className="flex items-baseline gap-x-2 text-nowrap text-3xl font-semibold tracking-tight text-gray-900">
        {Boolean(originalCost) && (
          <div>
            <span>$</span>
            <span className="line-through">{originalCost}</span>
          </div>
        )}

        <div>
          <span>$</span>
          <span>{cost}</span>
        </div>

        <span className="text-base/7 font-semibold text-gray-600">
          per month
        </span>
      </div>

      {i.type === "annually" && (
        <span className="text-gray-600 text-left text-xs">
          {+originalCost > 0
            ? "20% discount billed annually"
            : "Not applicable"}
        </span>
      )}

      <Button
        loading={loading === i.id}
        disabled={isCurrentPlan && +active_plan.cost === 0}
        onClick={() => onSubmit(i)}
        type="button"
      >
        {submitLabel}
      </Button>

      <div className="w-full border-b" />

      <p className="p-0 m-0 font-semibold text-nowrap">{i.description}</p>

      <PlanFeatures features={features} />

      {otherFeatures?.length > 0 && (
        <>
          <div className="w-full border-b" />
          <PlanFeatures features={otherFeatures} />
        </>
      )}
    </div>
  );
};

export default SubscriptionPlanCard;
